import React from "react";
import NavigateButton from "./ActionsButton/NavigateButton";
import LeanModalButton from "./ActionsButton/LeanModalButton";
import { useTranslation } from "react-i18next";

// Navigation ("drill-in") actions for an inventory row, rendered as a fragment.
const RowActions = React.memo(({ inventory }) => {
  const { t } = useTranslation();

  return (
    <>
      <NavigateButton application={inventory} path="/scope">
        {t("scopes")}
      </NavigateButton>
      <NavigateButton application={inventory} path="/reorder">
        {t("sortBy")}
      </NavigateButton>
      {/* Matching pairs questions by their order number, so it needs the question ordering
          saved first. That snapshot is QuestionsImage.QuestionsJson (formerly "TestImage");
          CheckboxQuestionsJson doesn't count — the match page skips checkbox questions. */}
      <NavigateButton
        application={inventory}
        path="/match"
        disabled={!inventory.questionsImage?.questionsJson}
        disabledReason={t("matchRequiresOrdering")}
      >
        {t("match")}
      </NavigateButton>
      <LeanModalButton inventory={inventory} />
      <NavigateButton application={inventory} path="/info">
        {t("applicationInfo")}
      </NavigateButton>
      <NavigateButton application={inventory} path="/scheme">
        {t("scheme")}
      </NavigateButton>
      <NavigateButton application={inventory} path="/answers">
        {t("answers")}
      </NavigateButton>
    </>
  );
});

export default RowActions;
